import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './helpers/api.service';
import { apiResourcesV1 } from './helpers/api-resources';
import { TokenStorageService } from './helpers/token.service';
import { AuthResponse } from '../interfaces/auth-response.interface';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class AuthService {
  private refreshTokenTimeout;
  constructor(private http: ApiService,
              private tokenStorage: TokenStorageService) {
  }

  login(data: any): Observable<AuthResponse> {
    return this.http.post(apiResourcesV1.signIn, data)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  reset(data: string): Observable<any> {
    return this.http.post(apiResourcesV1.forgotPassword, data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  changePassword(data: string): Observable<any> {
    return this.http.post(apiResourcesV1.resetPassword, data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  registration(data: string): Observable<any> {
    return this.http.post(`${apiResourcesV1.registration}`, data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getProfile(): Observable<any> {
    return this.http.get(apiResourcesV1.profile)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  setUser() {
    sessionStorage.setItem('authorization', 'true');
  }

  clearStorage() {
    sessionStorage.clear();
    localStorage.clear();
  }
  logout(): Observable<any> {
    return this.http.post(apiResourcesV1.signOut, {}).pipe(
      map((res: any) => {
        this.stopRefreshTokenTimer();
        return res;
      }),
    );
  }
  refreshToken() {
    const refresh = this.tokenStorage.getRefreshToken();
    const token = this.tokenStorage.getToken();
    return this.http.post(apiResourcesV1.refreshToken, {
      refresh_token: refresh,
      access_token: token
    }, httpOptions).pipe(map((res: any) => {
      this.tokenStorage.saveToken(res.token.access_token);
      this.tokenStorage.saveRefreshToken(res.token.refresh_token);
      this.tokenStorage.saveExpireRefreshToken(res.token.refresh_expire);
      this.tokenStorage.saveExpireToken(res.token.access_expire);
      setTimeout(() => {
        this.startRefreshTokenTimer();
      }, 200);

      return res;
    }));
  }
  // helper methods
  startRefreshTokenTimer() {
    const expires = new Date(Number(this.tokenStorage.getExpireToken()) * 1000);
    const timeout = expires.getTime() - Date.now() - (60 * 1000);
    this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
  }

  private stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }
}
